import { Box, Divider, IconButton, Text } from '@wix/design-system';
import { ExternalLink } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useSelector, useStore } from 'react-redux';

import { logOpenArticleInHCAction } from '../../../bi';
import { selectArticleHeadingVisible } from '../../../common/selectors/helpCenter';
import s from './styles.scss';

export type SubtitleProps = {
  href: string;
  articleId: string;
  text?: string;
};

export const Subtitle: FC<SubtitleProps> = ({ text, href, articleId }) => {
  const store = useStore();
  const articleHeadingVisible = useSelector(selectArticleHeadingVisible);

  const logOpenArticleInHC = useCallback(() => {
    const state = store.getState();
    logOpenArticleInHCAction(state, { id: articleId });
  }, [store, articleId]);

  if (!articleHeadingVisible) {
    return null;
  }

  return (
    <>
      <Box
        position="absolute"
        width="100%"
        padding="6px 18px"
        backgroundColor="D80"
        justifyContent="space-between"
        verticalAlign="middle"
        zIndex={1} // need to show above the Article Container
      >
        <Text size="medium" style={{ maxWidth: '72%' }} ellipsis dataHook="help-center-subtitle__text">
          {text}
        </Text>
        <IconButton
          className={s.subtitleIcon}
          as="a"
          href={href}
          target="_blank"
          skin="light"
          dataHook="help-center-subtitle__link"
          onClick={logOpenArticleInHC}
        >
          <ExternalLink />
        </IconButton>
      </Box>
      <Divider />
    </>
  );
};
